// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.Article_article__qVzxM {
  display: flex;
  flex-direction: column;
  height: -moz-fit-content;
  height: fit-content;
  padding: 24px;
  gap: 6px;
  border-radius: 10px 10px 10px 10px;
  opacity: 0px;
  box-shadow: 0px 4px 20px 0px rgba(5, 0, 255, 0.2509803922);
  background: #FFFFFF;
}
.Article_article__qVzxM:hover .Article_heading__ctAO8 {
  color: #8000FF;
}

.Article_info__S9zBb {
  display: grid;
  grid-template-columns: 7fr 2fr;
}

.Article_content__GsD8P {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Article_image__7LO7C {
  justify-self: end;
  width: 200px;
  height: 200px;
}

.Article_heading__ctAO8 {
  margin: 0;
  flex-wrap: wrap;
  font-family: "Roboto Mono", "Arial", monospace;
  color: #333333;
  line-height: 1.2em;
}

.Article_text__JxAfE {
  font-size: 16px;
  line-height: 110%;
  font-family: "Roboto Mono", "Arial", monospace;
  flex-wrap: wrap;
  padding: 0px 0px 0px 16px;
}

.Article_article-link__RJ3Av {
  padding: 5px 5px 5px 16px;
  width: -moz-fit-content;
  width: fit-content;
}

.Article_examples__DhWI0 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-top: 1px solid #8000FF;
  padding: 5px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/pages/articles/article/Article.module.sass","webpack://./src/assets/styles/mixins.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;ACjBA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kCAAA;EACA,YAAA;EACA,0DAAA;EACA,mBDFS;ACGb;AACI;EAGI,cDJC;ACGT;;AAGA;EACI,aAAA;EACA,8BAAA;AAAJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AACA;EACI,iBAAA;EACA,YAAA;EACA,aAAA;AAEJ;;AACA;EACI,SAAA;EACA,eAAA;EACA,8CDhBS;ECiBT,cD3BS;EC4BT,kBAAA;AAEJ;;AAAA;EClCI,eAAA;EACA,iBAAA;EDmCA,8CDtBS;ECuBT,eAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,uBAAA;EAAA,kBAAA;AAKJ;;AAFA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,6BAAA;EACA,kBAAA;AAKJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../../../assets/styles/variables\" as *\r\n@use \"../../../../assets/styles/mixins\" as mix\r\n\r\n.article\r\n    display: flex\r\n    flex-direction: column\r\n    height: fit-content\r\n    padding: 24px\r\n    gap: 6px\r\n    border-radius: 10px 10px 10px 10px\r\n    opacity: 0px\r\n    box-shadow: 0px 4px 20px 0px $base-shadow\r\n    background: $base-white\r\n\r\n    &:hover .heading\r\n        // text-decoration: underline solid $accent 1px\r\n        // text-underline-offset: 9px\r\n        color: $accent\r\n\r\n.info \r\n    display: grid\r\n    grid-template-columns: 7fr 2fr\r\n\r\n.content\r\n    display: flex\r\n    flex-direction: column\r\n    gap: 10px\r\n\r\n.image \r\n    justify-self: end\r\n    width: 200px\r\n    height: 200px\r\n\r\n\r\n.heading\r\n    margin: 0\r\n    flex-wrap: wrap\r\n    font-family: $fm-primary\r\n    color: $base-black\r\n    line-height: 1.2em\r\n\r\n.text\r\n    @include mix.text-2\r\n    font-family: $fm-primary\r\n    flex-wrap: wrap\r\n    padding: 0px 0px 0px 16px\r\n\r\n.article-link\r\n    padding: 5px 5px 5px 16px\r\n    width: fit-content\r\n\r\n\r\n.examples\r\n    display: flex\r\n    flex-direction: column\r\n    gap: 5px\r\n    border-top: 1px solid $accent\r\n    padding: 5px 0 0 0\r\n\r\n","@use \"./variables\" as *\r\n\r\n@mixin text-1\r\n    font-size: 20px\r\n    line-height: 120%\r\n\r\n@mixin text-2\r\n    font-size: 16px\r\n    line-height: 110%\r\n\r\n@mixin text-3\r\n    font-size: 12px\r\n    line-height: 110%\r\n\r\n@mixin container\r\n    max-width: $desktop-max\r\n    margin: 0 auto\r\n    width: calc(100vw - $desktop-offset * 2)\r\n\r\n    @media (max-width: $mobile-max)\r\n        width: calc(100vw - $mobile-offset * 2)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"article": `Article_article__qVzxM`,
	"heading": `Article_heading__ctAO8`,
	"info": `Article_info__S9zBb`,
	"content": `Article_content__GsD8P`,
	"image": `Article_image__7LO7C`,
	"text": `Article_text__JxAfE`,
	"article-link": `Article_article-link__RJ3Av`,
	"examples": `Article_examples__DhWI0`
};
export default ___CSS_LOADER_EXPORT___;
